export default "__VITE_ASSET__D5WEN836__"